import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert, UncontrolledTooltip, Table, Spinner, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import Session from '../auth/Session';
import { FaSort } from 'react-icons/fa'
import utilities from '../util/utilities';
import { Typeahead } from 'react-bootstrap-typeahead';
import moment from "moment";

//Warm Gray - #5C5C5C
//Orange - #F26230 #FFFFFF
//Light Gray - #DDDDDD
//Almost Black - #373737
//backgroundColor: '#F26230', color: '#FFFFFF'

export class LeaseDetailsRentTerms extends Component {
    static displayName = LeaseDetailsRentTerms.name;

    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('id');

        this.state = {
            clientOptions: [],
            client: null,
            clientText: null,
            search: null,
            rentTerms: [],
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100000,
            numberOfPages: 0,
            testType: 'Selection',
            testLevel: 'MA',
            leaseId: id,
            typeOptions: [{ label: "Base Rent", value: "Base Rent" },
            { label: "CAM", value: "CAM" },
            { label: "RE Taxes", value: "RE Taxes" },
            { label: "Insurance", value: "Insurance" },
            { label: "Security Deposit", value: "Security Deposit" },
            { label: "Operating Expenses", value: "Operating Expenses" },
            { label: "Other", value: "Other" }],
            tn_editMode: false,
            term_notes: {},
            lease: {}, //For header
            isAdmin: false
        };
        this.checkAuthenticated();
        this.GetLease(); //For header
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isWrite = false;
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isWrite = await AdminFunctions.isRole("Write");
        }
        this.setState({ isAdmin: isAdmin || isWrite });
    }

    async componentDidMount() {
        var _token = Session.getToken();
        //this.ShowAllLeases();
        this.GetRentTerms();
        this.GetRTNote();
        //var data = [{ sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 1 },
        //    { sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 0 }];
        //this.setState({ rentTerms: data });
    }


    //For Pageing!
    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.rentTerms.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    async handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    async handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.rentTerms.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.rentTerms.length / pageSize) })
        }
    }

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.rentTerms;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            valA = valA.toString(); //How do we fix?
            valB = valB.toString(); //How do we fix?
            return valA.localeCompare(valB);
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            rentTerms: data,
            sort: {
                column,
                direction
            }
        })
    }
    handleSortInt(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.rentTerms;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            //return valA.localeCompare(valB);
            if (valA < valB) {
                return -1;
            } else if (valA > valB) {
                return 1;
            } else {
                return 0;
            }
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            rentTerms: data,
            sort: {
                column,
                direction
            }
        })
    }
    render() {

        // Logic for displaying rentTerms
        const currentItems = this.state.rentTerms;

        const renderItems = currentItems.map((candidate, i) => {
            return (
                <tr key={i} className={new Date(candidate.rt_start) < new Date() && new Date(candidate.rt_end) > new Date() ? 'highlightRow' : ''} >
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noPadding">
                        {candidate.editMode === false && (
                            <div>
                                {candidate.rt_type}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <select
                                    options={this.state.typeOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var rentTermsTemp = this.state.rentTerms;
                                        rentTermsTemp[i].rt_type = e.target.value;
                                        this.setState({ rentTerms: rentTermsTemp });
                                    }}
                                    value={candidate.rt_type}
                                    style={{ 'width': '163px' }}
                                >
                                    <option key=''></option>
                                    {this.state.typeOptions.map(option => {
                                        return (
                                            <option key={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noPadding">
                        {candidate.editMode === false && (
                            <div>
                                {moment(candidate.rt_start, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/yyyy")}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <input
                                    type="date"
                                    value={moment(candidate.rt_start, "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD")}
                                    onChange={(e) => {
                                        var rentTermsTemp = this.state.rentTerms;
                                        rentTermsTemp[i].rt_start = e.target.value;
                                        this.setState({ rentTerms: rentTermsTemp });
                                    }}
                                    name="rt_start"
                                    id='rt_start'
                                    style={{ 'width': '113px' }}
                                />
                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noPadding">
                        {candidate.editMode === false && (
                            <div>
                                {moment(candidate.rt_end, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/yyyy")}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <input
                                    type="date"
                                    value={moment(candidate.rt_end, "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD")}
                                    onChange={(e) => {
                                        var rentTermsTemp = this.state.rentTerms;
                                        rentTermsTemp[i].rt_end = e.target.value;
                                        this.setState({ rentTerms: rentTermsTemp });
                                    }}
                                    name="rt_end"
                                    id='rt_end'
                                    style={{ 'width': '113px' }}
                                />
                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noPadding">
                        {candidate.editMode === false && (
                            <div>
                                {candidate.rt_monthly != null ? '$' + candidate.rt_monthly.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <input
                                    type="number"
                                    value={candidate.rt_monthly}
                                    onChange={(e) => {
                                        var rentTermsTemp = this.state.rentTerms;
                                        rentTermsTemp[i].rt_monthly = e.target.value;
                                        this.setState({ rentTerms: rentTermsTemp });
                                    }}
                                    name="rt_monthly"
                                    id='rt_monthly'
                                    style={{ 'width': '80px' }}
                                />
                            </div>
                        )}

                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noPadding">
                        <div>
                            {candidate.rt_psqft != null ? '$' + candidate.rt_psqft.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}
                        </div>
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noPadding">
                        {candidate.editMode === false && (
                            <div>
                                {candidate.rt_notes}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <textarea
                                    type="textarea"
                                    value={candidate.rt_notes}
                                    onChange={(e) => {
                                        var rentTermsTemp = this.state.rentTerms;
                                        rentTermsTemp[i].rt_notes = e.target.value;
                                        this.setState({ rentTerms: rentTermsTemp });
                                    }}
                                    name="rt_notes"
                                    id='rt_notes'
                                    style={{ 'height': '80px', 'width': '409px' }}
                                />
                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noRightPadding">
                        {candidate.editMode === false && (
                            <div>

                                <Button
                                    color='primary'
                                    onClick={() => {
                                        var rentTermsTemp = this.state.rentTerms;
                                        rentTermsTemp[i].prevTerms = Object.assign({}, rentTermsTemp[i]);
                                        rentTermsTemp[i].editMode = true;
                                        this.setState({ rentTerms: rentTermsTemp });
                                    }}
                                    className="g-orange-bg g-orange-c g-orange-button gButton smallMargin"
                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                    disabled={this.state.loading === true ? true : false}
                                    hidden={!this.state.isAdmin ? true : false}
                                >
                                    Edit
                                </Button>
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    var rentTermsTemp = this.state.rentTerms;
                                    if (this.IsEmpty(candidate) === true) {
                                        this.DeleteEmpty(i);
                                    }
                                    else {
                                        rentTermsTemp[i].editMode = false;
                                        this.setState({ rentTerms: rentTermsTemp });
                                        this.SaveRentTerm(candidate, i);
                                    }

                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton smallMargin"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                {this.IsEmpty(candidate) === false ? 'Save' : 'Delete'}
                            </Button>
                        )}
                        {candidate.editMode === true && candidate.rt_id !== 0 && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    var rentTermsTemp = this.state.rentTerms;
                                    rentTermsTemp[i] = rentTermsTemp[i].prevTerms;
                                    rentTermsTemp[i].prevTerms = {};
                                    rentTermsTemp[i].editMode = false;
                                    this.setState({ rentTerms: rentTermsTemp });

                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton smallMargin"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                Cancel
                            </Button>
                        )}
                        {candidate.editMode === true && candidate.rt_id !== 0 && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    this.DeleteExisting(candidate, i);
                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton smallMargin"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                Delete
                            </Button>
                        )}
                    </td>
                </tr>
            )
        });

        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Lease Details</h3>
                </div>
                <div id="body" className="g-warm-gray-c">
                    <Row>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>
                            <label className="g-almost-black-c addressTitle">
                                {this.state.lease.sd_address}<br />
                                {this.state.lease.sd_city}, {this.state.lease.sd_state} {this.state.lease.sd_zip}
                            </label> {/*//For header*/}
                        </Col>
                    </Row>
                    <Row className="g-warm-gray-bg g-warm-gray-c" style={{ 'textAlign': 'center' }}>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Summary?id=' + this.state.leaseId}
                            >
                                Summary
                            </NavLink>
                        </Col>
                        <Col className="g-orange-bg g-orange-c">
                            Rent Terms
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-CriticalDates?id=' + this.state.leaseId}
                            >
                                Critical Dates
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Notes?id=' + this.state.leaseId}
                            >
                                Notes
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Documents?id=' + this.state.leaseId}
                            >
                                Documents
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Contacts?id=' + this.state.leaseId}
                            >
                                Contacts
                            </NavLink>
                        </Col>
                    </Row>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row className="rowSpacing noBottomBorder">
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '100px' }}>
                                            Type
                                            <FaSort
                                                color={this.state.sort.column === 'rt_type' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('rt_type')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '106px' }}>
                                            Start
                                            <FaSort
                                                color={this.state.sort.column === 'rt_start' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('rt_start')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '106px' }}>
                                            End
                                            <FaSort
                                                color={this.state.sort.column === 'rt_end' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('rt_end')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '114px' }}>
                                            Monthly
                                            <FaSort
                                                color={this.state.sort.column === 'rt_monthly' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('rt_monthly')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '118px' }}>
                                            Per SQFT
                                            <FaSort
                                                color={this.state.sort.column === 'rt_psqft' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('rt_psqft')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minwidth': '430px' }}>
                                            Notes
                                            <FaSort
                                                color={this.state.sort.column === 'rt_notes' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('rt_notes')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c buttonColumn" style={{ 'width': '106px' }}>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <tr>
                                            <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                <Spinner color="primary" children='' />
                                            </td>
                                        </tr>

                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                            <td className="noRightPaddingWithTop">
                                                            <Button
                                                                color='primary'
                                                                onClick={() => {
                                                                    this.AddRows(20);
                                                                }}
                                                                    className="g-orange-bg g-orange-c g-orange-button gButton smallMargin"
                                                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                                    disabled={this.state.loading === true ? true : false}
                                                                    hidden={!this.state.isAdmin ? true : false}
                                                            >
                                                                Add
                                                            </Button>
                                                            <Button
                                                                color='primary'
                                                                onClick={() => {
                                                                    this.SaveAll();
                                                                }}
                                                                    className="g-orange-bg g-orange-c g-orange-button gButton smallMargin"
                                                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                                    disabled={this.state.loading === true ? true : false || !this.state.rentTerms.find(w => w.editMode === true)}
                                                                    hidden={!this.state.isAdmin ? true : false}
                                                            >
                                                                Save All
                                                            </Button>
                                                            <Link
                                                                to="/Lease/ActiveLeases?search=1"
                                                                color='primary'
                                                                    className="g-orange-bg g-orange-c g-orange-button gButton btn btn-primary smallMargin"
                                                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", padding: '5px', marginLeft: '10px' }}
                                                                disabled={this.state.loading === true ? true : false}
                                                            >
                                                                Back To List
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                    {this.state.tn_editMode === false && (
                                                            <tr className="noBoarder noBottomBorder" style={{ 'marginTop': '10px' }}>
                                                                <td className="noBoarder noBottomBorder textLabel noRightPaddingWithTop">
                                                                <label>General Notes: </label>
                                                            </td>

                                                                <td colSpan="5" className="noBoarder noBottomBorder noRightPaddingWithTop">
                                                                <label>{this.state.term_notes.tn_note}</label>
                                                            </td>
                                                                <td className="noBoarder noBottomBorder noRightPaddingWithTop">
                                                                <Button
                                                                    color='primary'
                                                                    onClick={() => {
                                                                        this.setState({ tn_editMode: true });
                                                                        this.setState({ tn_oldNote: this.state.term_notes.tn_note });
                                                                        this.setState({ tn_newNote: this.state.term_notes.tn_note });
                                                                    }}
                                                                        className="g-orange-bg g-orange-c g-orange-button gButton smallMargin"
                                                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                                        disabled={this.state.loading === true ? true : false}
                                                                        hidden={!this.state.isAdmin ? true : false}
                                                                >
                                                                    Edit
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {this.state.tn_editMode === true && (
                                                        <tr className="noBoarder">
                                                                <td className="noBoarder noBottomBorder textLabel noRightPaddingWithTop">
                                                                <label>General Notes:</label>
                                                            </td>

                                                            <td colSpan="5" className="noBoarder noBottomBorder noRightPaddingWithTop" >
                                                                <textarea
                                                                    type="textarea"
                                                                    value={this.state.tn_newNote}
                                                                    onChange={(e) => {
                                                                        this.setState({ tn_newNote: e.target.value });
                                                                    }}
                                                                    name="tn_note"
                                                                    id='tn_note'
                                                                    style={{ 'height': '137px', 'width': '915px' }}
                                                                />
                                                            </td>
                                                                <td className="noBoarder noBottomBorder noRightPaddingWithTop">
                                                                <Button
                                                                    color='primary'
                                                                    onClick={() => {
                                                                        this.EditTermNote();
                                                                    }}
                                                                        className="g-orange-bg g-orange-c g-orange-button gButton smallMargin"
                                                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                                        disabled={this.state.loading === true ? true : false}
                                                                        hidden={!this.state.isAdmin ? true : false}
                                                                >
                                                                    Save
                                                                </Button>
                                                                <Button
                                                                    color='primary'
                                                                    onClick={() => {
                                                                        this.setState({ tn_editMode: false });
                                                                    }}
                                                                    className="g-orange-bg g-orange-c g-orange-button gButton smallMargin"
                                                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                                        disabled={this.state.loading === true ? true : false}
                                                                        hidden={!this.state.isAdmin ? true : false}
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <h5>No Results Found</h5>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    async GetRentTerms() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetRentTerms?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        })
        const data = await response.json();
        this.setState({ rentTerms: data });
    }
    async GetRTNote() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetRTNote?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        })
        const data = await response.json();
        this.setState({ term_notes: data });
    }
    async EditTermNote() {
        //Save the change!
        var termNotesTemp = this.state.term_notes;
        termNotesTemp.tn_note = this.state.tn_newNote;
        termNotesTemp.sd_id = this.state.leaseId;
        termNotesTemp.active = true;
        this.setState({ term_notes: termNotesTemp });
        this.setState({ tn_editMode: false });
        const token = Session.getToken();
        const response = await fetch('api/Leases/EditRTNote', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.term_notes)
        })
    }
    AddRows(number) {
        for (var i = 0; i < number; i++) {
            var newRow = { rt_id: 0, sd_id: this.state.leaseId, site_details: null, rt_type: '', rt_start: null, rt_end: null, rt_months: null, rt_monthly: null, rt_annual: null, rt_psqft: null, rt_notes: null, editMode: true };
            var rentTermsTemp = this.state.rentTerms;
            rentTermsTemp.push(newRow);
            this.setState({ rentTerms: rentTermsTemp });
        }
    }
    IsEmpty(candidate) {
        if (candidate.rt_type || candidate.rt_start || candidate.rt_end || candidate.rt_monthly || candidate.rt_notes) {
            //If anything is filled out, it's not empty.
            return false;
        }
        if (candidate.rt_id) {
            //If it's not a new item, it's not considered empty for this.
            return false;
        }
        return true;
    }
    DeleteEmpty(index) {
        var rentTermsTemp = this.state.rentTerms;
        rentTermsTemp.splice(index, 1);
        this.setState({ rentTerms: rentTermsTemp });
    }
    async SaveRentTerm(candidate, index) {
        const token = Session.getToken();
        const response = await fetch('api/Leases/EditRentTerm', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(candidate)
        });

        const data = await response.json();

        if (data) {
            if (data.rt_id > 0) {
                var rentTermsTemp = this.state.rentTerms;
                rentTermsTemp[index].rt_id = data.rt_id;
                rentTermsTemp[index].rt_psqft = data.rt_psqft;
                rentTermsTemp[index].editMode = false;
                this.setState({ contacts: rentTermsTemp });
            }
        }
    }
    async DeleteExisting(candidate, index) {
        if (window.confirm("Are you sure you want to delete this Rent Term?") === true) {
            const token = Session.getToken();
            const response = await fetch('api/Leases/DeleteRentTerm?id=' + candidate.rt_id, {
                method: 'GET',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            })

            var rentTermsTemp = this.state.rentTerms;
            rentTermsTemp.splice(index, 1);
            this.setState({ rentTerms: rentTermsTemp });
        }
    }

    async SaveAll(apple) {
        try {
            this.setState({ loading: true });
            //Delete empties.
            var rentTermsTemp = this.state.rentTerms;
            //Loop backwards cuz we'll be slicin' and dicing this array, avoid index nonsense.
            for (let i = rentTermsTemp.length - 1; i >= 0; i--) {
                if (this.IsEmpty(rentTermsTemp[i])) {
                    this.DeleteEmpty(i);
                } else if (rentTermsTemp[i].editMode && !this.IsEmpty(rentTermsTemp[i])) {
                    await this.SaveRentTerm(rentTermsTemp[i], i);
                }
            }
            this.setState({ loading: false });
        } catch (ex) {
            this.setState({ loading: false });
            throw ex;
        }

    }
    //For header
    async GetLease() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetLease?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },

        })
        const data = await response.json();
        this.setState({ lease: data });
    }
}


